module.exports = __webpack_public_path__ + "img/forgot-password-logo-and-illustration.ae243d14.svg";